import AppFrame from '../components/AppFrame'
import User from '../components/ListUsers/User'

const UserPage = () => (
    <User />
)

export default UserPage
